import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { connect } from "react-redux";
import Agendamento from "./components Tarefas/Agendamento";
import Arquivo from "./components Tarefas/Arquivo";
import ArquivoFirebird from "./components Tarefas/ArquivoFirebird";
import Configuracoes from "./components Tarefas/Configuracoes";
import SQLBackup from "./components Tarefas/SQLBackup";
import PostgreSQLBackup from "./components Tarefas/PostgreSQLBackup";
import Substituicao from "./components Tarefas/Substituicao";


function TabsConfigTarefas(props) {

    const { dadosTarefa } = props

    return (
        <Tabs defaultActiveKey="arquivo" className="nav-pills mt-4">
            <Tab eventKey="arquivo" title="Arquivo" className="no-border">
                {
                    props.dadosTarefa.backup === 0 ?
                        <Arquivo tema={props.tema} setDadosTarefa={props.setDadosTarefa} dadosTarefa={props.dadosTarefa} /> :
                        props.dadosTarefa.backup === 1 ?
                            <ArquivoFirebird dadosTarefa={props.dadosTarefa} setDadosTarefa={props.setDadosTarefa} tema={props.tema} /> :
                            props.dadosTarefa.backup === 5 ?
                                <PostgreSQLBackup dadosTarefa={props.dadosTarefa} setDadosTarefa={props.setDadosTarefa} tema={props.tema} /> :
                                <SQLBackup dadosTarefa={props.dadosTarefa} setDadosTarefa={props.setDadosTarefa} tema={props.tema} />
                }
            </Tab>
            <Tab eventKey="configurações" title="Configurações">
                <Configuracoes tema={props.tema} dadosTarefa={props.dadosTarefa} setDadosTarefa={props.setDadosTarefa} dadosUsuario={props.dadosUsuario} />
            </Tab>
            <Tab eventKey="agendamento" title="Agendamento">
                <div className=" border rounded-md p-2 mt-2">
                    <Agendamento dadosTarefa={props.dadosTarefa} setDadosTarefa={props.setDadosTarefa} dadosUsuario={props.dadosUsuario} />
                </div>
            </Tab>
            <Tab eventKey="substituição" title="Substituição">
                <div className=" border rounded-md p-2 mt-2">
                    <Substituicao dadosTarefa={props.dadosTarefa} setDadosTarefa={props.setDadosTarefa} dadosUsuario={props.dadosUsuario} />
                </div>
            </Tab>
        </Tabs>
    );
}

const mapStateToProps = (state) => {
    return {
        tema: state.appReducer.tema,
        dadosUsuario: state.appReducer.dadosUsuario
    }
}

export default connect(mapStateToProps, null)(TabsConfigTarefas)